import api from '../api'

export const obtainTokens = async (accessToken: string, grantToken: string) => {
  const config = { headers: { Authorization: `Bearer ${accessToken}` } }
  const response = await api.post(`/zoho/${grantToken}`, null, config)
  return response.data
}
